<template>
  <div class="theHeader">
    <h1>
    Jakehub
    </h1>
  </div>
</template>
<style lang="scss" scoped>
.theHeader {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>